import { ButtonHTMLAttributes } from 'react';

interface IconButtonProps {
  onClick?: () => void;
}

export default function IconButton({
  onClick,
  children,
  ...props
}: IconButtonProps & ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  return (
    <>
      <button onClick={onClick} role="button" {...props}>
        {children}
      </button>
    </>
  );
}
